import { useCallback } from "react";

import { useDateFnsLocale } from "Infrastructure/Hooks/DateFns/useDateFnsLocale";
import { format as dateFnsFormat } from "date-fns";

export const useFormatLocale = () => {
  const locale = useDateFnsLocale();

  return useCallback((date: number | Date, format = "P") => dateFnsFormat(date, format, { locale }), [locale]);
};
